import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./box-minus.svg?react";

export const BoxMinusIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
